import {CalendarStyles} from "@/enums/CalendarStyles";
import PrintableCalendarHeader
  from "@/views/calender/printable-calendar-components/printable-calendar-header/PrintableCalendarHeader.vue";
import {CalendarTypeEnum} from "@/enums/CalendarTypeEnum";
import PrintableCalendarListHeader
  from "@/views/calender/printable-calendar-components/printable-calendar-list-header/PrintableCalendarListHeader.vue";
export default {
  name: "PrintableCalendarPdf",
  components: {
    PrintableCalendarHeader,
    PrintableCalendarListHeader
  },
  props: {
    paperFormat: {
      type: String
    },
    pdfOrientation: {
      type: String
    },
    printableCalendarUrl: {
      type: String
    },
    printableCalendarColor: {
      type: String
    },
    printCalendarScreens: {
      type: Array
    },
    printCalendarStyle: {
      type: String
    },
    isCalendarFilteredByWings: {
      type: Boolean
    },
    isRemoveBorder: {
      type: Boolean
    },
    isCalendarMonthLocation: {
      type: Boolean
    },
    printCalendarFormat: {
      type: String
    },
    calendarStartDay: {
      type: Date
    },
    locations: {
      type: Array
    },
    calendarDescription: {
      type: String
    },
    facilityLogo: {
      type: String
    },
    locationsWithShortCode: {
      type: String
    },
    isMonth: {
      type: Boolean
    },
    isWeek: {
      type: Boolean
    },
    is2Weeks: {
      type: Boolean
    },
    isDay: {
      type: Boolean
    },
    headerFont: {
      type: String
    },
    headerFontColor: {
      type: String
    },
    headerSize: {
      type: String
    },
    careLevels: {
      type: Array
    },
    selectedWingsPrintableCalendar: {
      type: Array
    },
    isUseWingsCustomNameEnabled: {
      type: Boolean
    },
    wingsCustomNameDescription: {
      type: String
    },
    isWeekCompact: {
      type: Boolean
    },
    printableCalendarCustomImage: {
      type: String
    },
    locationKeysSize: {
      type: String
    },
    locationKeys: {
      type: Boolean
    },
    logoSizeComputed: {
      type: Object
    },
    customPhotoSizeComputed: {
      type: Object
    },
    isUseFacilityCustomNameEnabled: {
      type: Boolean
    },
    facilityCustomName: {
      type: String
    },
    locationsSizeHeaderComputed: {
      type: Object
    },
    customTextBoxSizeHeaderComputed: {
      type: Object
    },
    inputCustomBoxColor: {
      type: String
    },
    inputCustomBoxSize: {
      type: String
    },
    printableCalendarImages: {
      type: Array
    },
    printableCalendarTextBoxes: {
      type: Array
    },
    pagination: {
      type: Array
    },
    locationsKeys: {
      type: Array
    },
    printableCalendarBorderColor: {
      type: String
    }
  },
  data() {
    return {
      printableCalendarMainPDF: null,
      printableCalendarMainPDFSlide: null
    }
  },
  mounted() {
    this.printableCalendarMainPDF = this.$refs.printableCalendarMainPDF;
    this.printableCalendarMainPDFSlide = this.$refs.printableCalendarMainPDFSlidePreview;
  },
  computed: {
    isPrintList() {
      return this.printCalendarStyle === this.printCalendarStyles.list;
    },
    isPrintCalendar() {
      return this.printCalendarStyle === this.printCalendarStyles.calendar;
    },
    printCalendarStyles() {
      return CalendarStyles;
    },
    typeToLabel() {
      return CalendarTypeEnum;
    }
  }
}